import styled from 'styled-components';

import { media } from '@utils/styled';

import Button, { BUTTON_VARIANTS } from '@common/components/Button';
import TextInput from '@common/components/forms/TextInput';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  white-space: nowrap;
  ${({ theme }) => theme.getFluidSpacing('grid-gap', 'equal', 3)}
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 3)};

  ${media.from800up`
    grid-template-columns: 1fr auto;
  `}
`;

export const InputGroup = styled.div`
  display: flex;
`;

export const NearMeButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  text-align: right;

  ${media.from800up`
      height: auto;
  `}
`;

export const Input = styled(TextInput)`
  flex: 1;

  input {
    flex: 1;
    width: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
  }
`;

export const SearchButton = styled(Button).attrs({
  variant: BUTTON_VARIANTS.LEVEL_1_FACEBOOK_BLUE,
})`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5rem;
  height: auto;
  margin: 0;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  padding: 0;
`;
